var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTier({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1.6,
    rx: 0.8,
    fill: "#062229"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.20001,
    width: 8.55556,
    height: 1.6,
    rx: 0.8,
    fill: "#062229"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 6.39999,
    width: 6.11111,
    height: 1.6,
    rx: 0.8,
    fill: "#062229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier);
export default __webpack_public_path__ + "static/media/tier.31004254e3906b1e75f8a271dcd282db.svg";
export { ForwardRef as ReactComponent };